module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAAAXNSR0IArs4c6QAAARpJREFUOE/l1K1KREEYxvH/kwyK7IYFm2u07EVYNloEhUUFMQiiYYNXIGKy6g1o1SSiaNBgslhsgmVvYEUQxEcGjsFzzpyPZZtTprzzm3k/GDHmpTF7lIK2J4ATYAk4A7YlfcUeUgjangQugGmgDxwDL0AvhkZB203gEvgAFiW9224Bt0VoLmh7BrgGXoFlSZ+/KZahGdB2G7gBHoGNvNSK0D+g7fkEOwd2JTlW/BiaBp+BK0l7VcYpQe+AU0mH4Uwa/AbmJL1VAUOM7XVgQVLYM2BIsV0T7AFdSWuVwSS1I0mr6ZfbHgnsAPeSGv8HnAX2R6nhEAjtf6o6NsAW0JK0mdflHeAAmKoBDoAVSQ8ZsAYSDS39YOte8gPQKaYV7/k4QwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/leftbar_icon_home_s.png
// module id = vB7m
// module chunks = 0